import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import {RouterMode} from "vue-router/types/router";
import {introJsService} from "../modules/onboarding/intro/IntroJsService";
import {isInAndroidApp, isInMobileApp} from "../utils/MobileUtils";
import { Platform } from 'quasar'

Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export const router = new VueRouter({
  // @ts-ignore
  scrollBehavior (to, from, savedPosition) {
    // savedPosition is only available for popstate navigations.
    if (savedPosition) {
      return savedPosition
    }

    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    if (to.params.savePosition) {
      return {}
    }

    // scroll to anchor by returning the selector
    if (to.hash) {
      return {selector: to.hash}
    }

    // scroll to top by default
    return {x: 0, y: 0}
  },
  routes,

  // Leave these as they are and change in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  mode: process.env.VUE_ROUTER_MODE as RouterMode,
  base: process.env.VUE_ROUTER_BASE,
});

router.afterEach((to, from) => {
  const lastRoute = from.name || '';
  sessionStorage.setItem('lastVisitedRoute', lastRoute);
  sessionStorage.setItem('lastVisitedUri', from.fullPath);

  if (from.name === 'Update' && !isInMobileApp()) {
    // @ts-ignore
    window.location.reload(true);
  }

  // Must be forced because page in not "reloaded" when routes changes so hints stay displayed
  introJsService.removeAllDisplayedHints();
})

/* Add universal Link
* Move implementation to App
*


import {isInMobileApp} from "../utils/MobileUtils";
// @ts-ignore
import { App } from '@capacitor/app';

if (isInMobileApp()) {
  App.addListener('appUrlOpen', function (data: any) {
    analyticsController.logBasicAnalyticsEvent('user opened app from universal link', 'Router', {url: data.url})
    if (data.url.includes('/#/')) {
      const resource = data.url.split('/#/').pop();
      router.push('/'+resource).then();
    }
    else {
      router.push('/home').then()
    }
  });
}
* */
export default router;
